import React from "react";
import { Card, Tag, Typography, Space, Button, Tooltip, theme } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  StarFilled,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { TaskTemplate } from "../../../../../types/taskTemplate";
const { Text, Title } = Typography;

interface TaskTemplateCardProps {
  template: TaskTemplate;
  onEdit: (template: TaskTemplate) => void;
  onDelete: (id: string) => void;
  onSetDefault: (id: string) => void;
}

const TaskTemplateCard: React.FC<TaskTemplateCardProps> = ({
  template,
  onEdit,
  onDelete,
}) => {
  const { token } = theme.useToken();

  return (
    <Card
      hoverable
      style={{ height: "100%" }}
      actions={[
        <Tooltip
          title={template.isActive ? "Edit Template" : "Template is inactive"}
        >
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEdit(template)}
            disabled={!template.isActive}
          />
        </Tooltip>,
        <Tooltip
          title={template.isActive ? "Delete Template" : "Template is inactive"}
        >
          <Button
            type="text"
            icon={<DeleteOutlined />}
            onClick={() => onDelete(template.id)}
            disabled={template.isDefault || !template.isActive}
            danger
          />
        </Tooltip>,
      ]}
    >
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 8,
            }}
          >
            <Title level={5} style={{ margin: 0 }}>
              {template.name}
            </Title>
            {template.isDefault && (
              <Tag color="gold" icon={<StarFilled />}>
                Default
              </Tag>
            )}
            {!template.isActive && <Tag color="default">Inactive</Tag>}
          </div>
          {template.description && (
            <Text type="secondary">{template.description}</Text>
          )}
          {template.category && (
            <div style={{ marginTop: 8 }}>
              <Tag color="blue">{template.category}</Tag>
            </div>
          )}
        </div>

        <div
          style={{
            padding: 16,
            backgroundColor: token.colorFillTertiary,
            borderRadius: 6,
            textAlign: "center",
          }}
        >
          <Space direction="vertical" size="small">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
              }}
            >
              <UnorderedListOutlined style={{ color: token.colorPrimary }} />
              <Text strong>Task Items</Text>
            </div>
            <div
              style={{
                fontSize: 24,
                fontWeight: 600,
                color: token.colorPrimary,
              }}
            >
              {template.items?.length || 0}
            </div>
          </Space>
        </div>

        <div style={{ fontSize: 12, color: token.colorTextSecondary }}>
          Created: {new Date(template.createdAt).toLocaleDateString()}
        </div>
      </Space>
    </Card>
  );
};

export default TaskTemplateCard;
